var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 8.5C15.0938 10.4848 13.4848 12.0938 11.5 12.0938C9.51523 12.0938 7.90625 10.4848 7.90625 8.5C7.90625 6.51523 9.51523 4.90625 11.5 4.90625C13.4848 4.90625 15.0938 6.51523 15.0938 8.5Z",
    fill: "#212529"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.5C0 8.5 4.3125 0.59375 11.5 0.59375C18.6875 0.59375 23 8.5 23 8.5C23 8.5 18.6875 16.4062 11.5 16.4062C4.3125 16.4062 0 8.5 0 8.5ZM11.5 13.5312C14.2787 13.5312 16.5312 11.2787 16.5312 8.5C16.5312 5.72132 14.2787 3.46875 11.5 3.46875C8.72132 3.46875 6.46875 5.72132 6.46875 8.5C6.46875 11.2787 8.72132 13.5312 11.5 13.5312Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.d2a0b5600ee7fc69ba498e6da1d5ab43.svg";
export { ForwardRef as ReactComponent };